export const MainArticleLayout = ({ children }) => {
  return (
    <div className="content-wrapper">
      <article className="main">{children}</article>
    </div>
  )
}
